// noinspection JSNonASCIINames,NonAsciiCharacters

export const careerOptions = [
  "Ciencia de la Computación",
  "Administración de Empresas",
  "Arquitectura y Urbanismo",
  "Contabilidad",
  "Derecho",
  "Educación Inicial",
  "Educación Primaria",
  "Ingeniería Ambiental",
  "Ingeniería Civil",
  "Ingeniería Electrónica y Telecomunicaciones",
  "Ingeniería Industrial",
  "Ingeniería Mecatrónica",
  "Psicología",
] as const;

export const semesterOptions = [
  "Semestre I",
  "Semestre II",
  "Semestre III",
  "Semestre IV",
  "Semestre V",
  "Semestre VI",
  "Semestre VII",
  "Semestre VIII",
  "Semestre IX",
  "Semestre X",
  "Semestre XI",
  "Semestre XII",
] as const;

type Course = { name: string; semester: typeof semesterOptions[number] };

export const courses: Record<typeof careerOptions[number], Course[]> = {
  "Ciencia de la Computación": [
    { name: "Programación de Video Juegos", semester: "Semestre I" },
    { name: "Estructura Discretas I", semester: "Semestre I" },
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática I", semester: "Semestre I" },
    {
      name: "Introducción de Ciencia de la Computación",
      semester: "Semestre II",
    },
    { name: "Ciencia de la Computación I", semester: "Semestre II" },
    { name: "Estructuras Discretas II", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre II" },
    { name: "Apreciación Musical", semester: "Semestre II" },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre II" },
    { name: "Matemática II", semester: "Semestre II" },
    { name: "Ciencia de la Computación II", semester: "Semestre III" },
    { name: "Álgebra Abstracta", semester: "Semestre III" },
    { name: "Arquitectura de Computadores", semester: "Semestre III" },
    { name: "Desarrollo Basado en Plataformas", semester: "Semestre III" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre III",
    },
    { name: "Apreciación Artística", semester: "Semestre III" },
    { name: "Apreciación Literaria", semester: "Semestre III" },
    { name: "Cálculo I", semester: "Semestre III" },
    { name: "Algoritmos y Estructura de Datos", semester: "Semestre IV" },
    { name: "Teoría de la Computación", semester: "Semestre IV" },
    { name: "Base de Datos I", semester: "Semestre IV" },
    { name: "Teología", semester: "Semestre IV" },
    { name: "Cálculo II", semester: "Semestre IV" },
    { name: "Estadística y Probabilidades", semester: "Semestre IV" },
    { name: "Física Computacional", semester: "Semestre V" },
    { name: "Análisis y Diseño de Algoritmos", semester: "Semestre V" },
    { name: "Base de Datos II", semester: "Semestre V" },
    { name: "Ingeniería de Software I", semester: "Semestre V" },
    { name: "Teatro", semester: "Semestre V" },
    { name: "Moral", semester: "Semestre V" },
    { name: "Análisis Numérico", semester: "Semestre V" },
    { name: "Ingeniería de Software II", semester: "Semestre VI" },
    { name: "Sistemas Operativos", semester: "Semestre VI" },
    { name: "Programación Competitiva", semester: "Semestre VI" },
    { name: "Estructuras de Datos Avanzadas", semester: "Semestre VI" },
    { name: "Oratoria", semester: "Semestre VI" },
    {
      name: "Matemática aplicada a la Computación",
      semester: "Semestre VI",
    },
    { name: "Redes y Comunicación", semester: "Semestre VII" },
    { name: "Computación Gráfica", semester: "Semestre VII" },
    { name: "Inteligencia Artificial", semester: "Semestre VII" },
    { name: "Lenguajes de Programación", semester: "Semestre VII" },
    { name: "Ingeniería de Software III", semester: "Semestre VII" },
    {
      name: "Metodología de la Investigación en Computación",
      semester: "Semestre VII",
    },
    { name: "Liderazgo", semester: "Semestre VII" },
    { name: "Computación en la Sociedad", semester: "Semestre VIII" },
    { name: "Interacción Humano Computador", semester: "Semestre VIII" },
    { name: "Compiladores", semester: "Semestre VIII" },
    { name: "Seguridad en Computación", semester: "Semestre VIII" },
    {
      name: "Computación Paralela y Distribuida",
      semester: "Semestre VIII",
    },
    { name: "Proyecto Final de Carrera I", semester: "Semestre VIII" },
    { name: "Historia de la Cultura", semester: "Semestre VIII" },
    { name: "Computación Molecular Biológica", semester: "Semestre IX" },
    { name: "Tópicos en Computación Gráfica", semester: "Semestre IX" },
    { name: "Tópicos en Inteligencia Artificial", semester: "Semestre IX" },
    { name: "Big Data", semester: "Semestre IX" },
    {
      name: "Tópicos Avanzados en Ingeniería de Software",
      semester: "Semestre IX",
    },
    { name: "Proyecto Final de Carrera II", semester: "Semestre IX" },
    {
      name: "Formación de Empresas de Base Tecnológica I",
      semester: "Semestre IX",
    },
    {
      name: "Historia de la Ciencia y Tecnología",
      semester: "Semestre IX",
    },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    { name: "Robótica", semester: "Semestre X" },
    { name: "Sistemas de Información", semester: "Semestre X" },
    { name: "Cloud Computing", semester: "Semestre X" },
    { name: "Proyecto Final de Carrera III", semester: "Semestre X" },
    {
      name: "Formación de Empresas de Base Tecnológica II",
      semester: "Semestre X",
    },
    { name: "Ética Profesional", semester: "Semestre X" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre X" },
    { name: "Inglés Técnico Profesional", semester: "Semestre X" },
  ],
  "Administración de Empresas": [
    { name: "Fundamentos de Marketing", semester: "Semestre I" },
    { name: "Fundamentos de Contabilidad", semester: "Semestre I" },
    { name: "Fundamentos de Administración", semester: "Semestre I" },
    { name: "Matemática Básica", semester: "Semestre I" },
    { name: "Comunicación I", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    { name: "Comportamiento del Consumidor", semester: "Semestre II" },
    { name: "Cálculo Financiero", semester: "Semestre II" },
    { name: "Derecho Empresarial I", semester: "Semestre II" },
    { name: "Álgebra y Geometría", semester: "Semestre II" },
    { name: "Comunicación II", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre II" },
    { name: "Apreciación Musical", semester: "Semestre II" },
    { name: "Oratoria", semester: "Semestre II" },
    { name: "Teatro", semester: "Semestre II" },
    { name: "Comportamiento Organizacional", semester: "Semestre III" },
    { name: "Derecho Empresarial II", semester: "Semestre III" },
    { name: "Análisis y Diseño de Procesos", semester: "Semestre III" },
    { name: "Cálculo en una Variable", semester: "Semestre III" },
    { name: "Costos Gerenciales", semester: "Semestre III" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre III",
    },
    { name: "Lógica y Argumentación", semester: "Semestre III" },
    { name: "Apreciación Artística", semester: "Semestre III" },
    { name: "Apreciación Literaria", semester: "Semestre III" },
    { name: "Investigación de Mercados", semester: "Semestre IV" },
    { name: "Macroeconomía I", semester: "Semestre IV" },
    { name: "Taller de Investigación I", semester: "Semestre IV" },
    { name: "Cálculo en Varias Variables", semester: "Semestre IV" },
    { name: "Estadística y Probabilidades", semester: "Semestre IV" },
    { name: "Costos y Presupuestos", semester: "Semestre IV" },
    {
      name: "Planeamiento y Control Presupuestal",
      semester: "Semestre IV",
    },
    { name: "Teología I", semester: "Semestre IV" },
    { name: "Gnoseología", semester: "Semestre IV" },
    { name: "Contabilidad Gerencial", semester: "Semestre V" },
    { name: "Macroeconomía II", semester: "Semestre V" },
    { name: "Creación y Organización de Empresas", semester: "Semestre V" },
    { name: "Cómputo", semester: "Semestre V" },
    { name: "Logística", semester: "Semestre V" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre V" },
    { name: "Moral", semester: "Semestre V" },
    { name: "Psicología", semester: "Semestre V" },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre V" },
    {
      name: "Formulación y Evaluación de Proyectos",
      semester: "Semestre VI",
    },
    { name: "Microeconomía I", semester: "Semestre VI" },
    { name: "Taller de Investigación II", semester: "Semestre VI" },
    { name: "Liderazgo", semester: "Semestre VI" },
    { name: "Estadística para Administradores", semester: "Semestre VI" },
    { name: "Gerencia de Ventas y Distribución", semester: "Semestre VI" },
    { name: "Gestión de Mercados", semester: "Semestre VI" },
    { name: "Teología II", semester: "Semestre VI" },
    {
      name: "Seguimiento y Control de Proyectos",
      semester: "Semestre VII",
    },
    { name: "Microeconomía II", semester: "Semestre VII" },
    { name: "Administración Pública", semester: "Semestre VII" },
    { name: "Auditoría Administrativa", semester: "Semestre VII" },
    { name: "Investigación de Operaciones", semester: "Semestre VII" },
    { name: "Administración de Operaciones", semester: "Semestre VII" },
    { name: "Técnicas de Gestión", semester: "Semestre VII" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre VII",
    },
    { name: "Finanzas", semester: "Semestre VIII" },
    { name: "Econometría", semester: "Semestre VIII" },
    { name: "E Business", semester: "Semestre VIII" },
    { name: "Política de Empresas", semester: "Semestre VIII" },
    { name: "Negocios Internacionales", semester: "Semestre VIII" },
    { name: "Gerencia de Producto y Precio", semester: "Semestre VIII" },
    { name: "Marketing de Servicios", semester: "Semestre VIII" },
    { name: "Marketing Internacional", semester: "Semestre VIII" },
    { name: "Riesgos y Seguros", semester: "Semestre VIII" },
    { name: "Operaciones Bancarias", semester: "Semestre VIII" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre VIII" },
    { name: "Proyectos Sociales", semester: "Semestre IX" },
    { name: "Gestión de PYMES", semester: "Semestre IX" },
    { name: "Gestión de Empresas Familiares", semester: "Semestre IX" },
    { name: "Sistemas de Información", semester: "Semestre IX" },
    { name: "Dirección de Personal", semester: "Semestre IX" },
    { name: "Planeamiento Estratégico", semester: "Semestre IX" },
    { name: "Internacionalización de Empresas", semester: "Semestre IX" },
    { name: "Gerencia de Comunicación", semester: "Semestre IX" },
    { name: "Gestión Comercial", semester: "Semestre IX" },
    { name: "Finanzas Avanzadas", semester: "Semestre IX" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    { name: "Organización Industrial", semester: "Semestre X" },
    { name: "Plan de Negocios", semester: "Semestre X" },
    { name: "Taller de Investigación III", semester: "Semestre X" },
    { name: "Administración de la Producción", semester: "Semestre X" },
    { name: "Gerencia Estratégica", semester: "Semestre X" },
    { name: "Plan de Marketing", semester: "Semestre X" },
    { name: "Mercados Financieros", semester: "Semestre X" },
    { name: "Ética Profesional", semester: "Semestre X" },
  ],
  "Arquitectura y Urbanismo": [
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Dibujo a Mano Alzada", semester: "Semestre I" },
    { name: "Geometría Descriptiva", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática", semester: "Semestre I" },
    { name: "Taller de Proyectos I", semester: "Semestre I" },
    {
      name: "Análisis y Composición de la Arquitectura I",
      semester: "Semestre II",
    },
    {
      name: "Apreciación Crítica de Artes Plásticas",
      semester: "Semestre II",
    },
    { name: "Apreciación Musical", semester: "Semestre II" },
    { name: "Expresión Arquitectónica", semester: "Semestre II" },
    { name: "Historia del Arte y la Cultura", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre II" },
    { name: "Taller de Proyectos II", semester: "Semestre II" },
    { name: "Teatro", semester: "Semestre II" },
    {
      name: "Análisis y Composición de la Arquitectura II",
      semester: "Semestre III",
    },
    { name: "Cine", semester: "Semestre III" },
    { name: "Epistemología", semester: "Semestre III" },
    { name: "Expresión Arquitectónica Digital", semester: "Semestre III" },
    { name: "Fotografía", semester: "Semestre III" },
    {
      name: "Historia de la Arquitectura Clásica",
      semester: "Semestre III",
    },
    { name: "Liderazgo", semester: "Semestre III" },
    { name: "Taller de Proyectos III", semester: "Semestre III" },
    {
      name: "Análisis y Composición de la Arquitectura III",
      semester: "Semestre IV",
    },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre IV",
    },
    {
      name: "Historia de la Arquitectura Moderna",
      semester: "Semestre IV",
    },
    { name: "Introducción a las Estructuras", semester: "Semestre IV" },
    {
      name: "Introducción al Building Information Modeling",
      semester: "Semestre IV",
    },
    { name: "Taller de Proyectos IV", semester: "Semestre IV" },
    {
      name: "Análisis y Composición de la Arquitectura IV",
      semester: "Semestre V",
    },
    {
      name: "Historia de la Arquitectura Contemporánea",
      semester: "Semestre V",
    },
    { name: "Ingeniería para Arquitectos I", semester: "Semestre V" },
    { name: "Metafísica y Estética", semester: "Semestre V" },
    { name: "Procesos Constructivos I", semester: "Semestre V" },
    { name: "Taller de Proyectos V", semester: "Semestre V" },
    { name: "Análisis del Paisaje Urbano", semester: "Semestre VI" },
    {
      name: "Historia de la Arquitectura Peruana I",
      semester: "Semestre VI",
    },
    { name: "Ingeniería para Arquitectos II", semester: "Semestre VI" },
    {
      name: "Metodología de la Investigación Científica",
      semester: "Semestre VI",
    },
    { name: "Procesos Constructivos II", semester: "Semestre VI" },
    { name: "Taller de Proyectos VI", semester: "Semestre VI" },
    { name: "Análisis del Espacio Urbano", semester: "Semestre VII" },
    {
      name: "Arquitectura de Espacios Escénicos",
      semester: "Semestre VII",
    },
    {
      name: "Arquitectura y Participación Ciudadana",
      semester: "Semestre VII",
    },
    {
      name: "Ecología y Sostenibilidad en la Arquitectura",
      semester: "Semestre VII",
    },
    {
      name: "Historia de la Arquitectura Peruana II",
      semester: "Semestre VII",
    },
    { name: "Iluminación y Acústica", semester: "Semestre VII" },
    { name: "Procesos Constructivos III", semester: "Semestre VII" },
    { name: "Taller de Proyectos VII", semester: "Semestre VII" },
    { name: "Teología", semester: "Semestre VII" },
    { name: "Topografía", semester: "Semestre VII" },
    { name: "Análisis de la Ciudad", semester: "Semestre VIII" },
    { name: "Ecología Urbana", semester: "Semestre VIII" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre VIII" },
    { name: "Gestión de Riesgos", semester: "Semestre VIII" },
    { name: "Instalaciones en Edificaciones", semester: "Semestre VIII" },
    { name: "Restauración de Monumentos", semester: "Semestre VIII" },
    {
      name: "Seminario de Arquitectura Latinoamericana Contemporánea",
      semester: "Semestre VIII",
    },
    {
      name: "Seminario de Patrimonio Arquitectónico",
      semester: "Semestre VIII",
    },
    {
      name: "Sistema de Información Geográfica",
      semester: "Semestre VIII",
    },
    { name: "Taller de Proyectos VIII", semester: "Semestre VIII" },
    {
      name: "Administración de Obras (LEAN Construction)",
      semester: "Semestre IX",
    },
    { name: "Ética Profesional", semester: "Semestre IX" },
    { name: "Gestión Estratégica", semester: "Semestre IX" },
    { name: "Renovación Urbana", semester: "Semestre IX" },
    {
      name: "Saneamiento Físico de Edificaciones",
      semester: "Semestre IX",
    },
    { name: "Seminario de Urbanismo", semester: "Semestre IX" },
    { name: "Taller de Investigación", semester: "Semestre IX" },
    { name: "Taller de Proyectos IX", semester: "Semestre IX" },
    { name: "Proyecto de Fin de Carrera I", semester: "Semestre X" },
    { name: "Proyecto de Investigación", semester: "Semestre X" },
    { name: "Proyectos de Inversión Pública", semester: "Semestre X" },
    {
      name: "Rehabilitación de Edificios Existentes",
      semester: "Semestre X",
    },
    { name: "Seminario de Vivienda", semester: "Semestre X" },
    { name: "Seminario Proyectual I", semester: "Semestre X" },
    { name: "Proyecto de Fin de Carrera II", semester: "Semestre X" },
    { name: "Seminario Proyectual II", semester: "Semestre X" },
  ],
  Contabilidad: [
    { name: "Matemática Básica", semester: "Semestre I" },
    { name: "Economía General", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    { name: "Comunicación I", semester: "Semestre I" },
    {
      name: "Procesos Documentarios Empresariales",
      semester: "Semestre I",
    },
    { name: "Fundamentos de Contabilidad", semester: "Semestre I" },
    { name: "Álgebra Lineal y Geometría", semester: "Semestre II" },
    {
      name: "Marco Conceptual de la Información Financiera",
      semester: "Semestre II",
    },
    { name: "Fundamentos Jurídicos Básicos", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre II" },
    { name: "Comunicación II", semester: "Semestre II" },
    { name: "Contabilidad Intermedia", semester: "Semestre II" },
    { name: "Teatro", semester: "Semestre II" },
    { name: "Apreciación Musical", semester: "Semestre II" },
    { name: "Cálculo en una Variable", semester: "Semestre III" },
    {
      name: "Antropología Filosófica y Teología",
      semester: "Semestre III",
    },
    { name: "Lógica y Gnoseología", semester: "Semestre III" },
    { name: "Contabilidad Superior", semester: "Semestre III" },
    {
      name: "Legislación Comercial y de Sociedades",
      semester: "Semestre III",
    },
    { name: "Legislación Laboral", semester: "Semestre III" },
    { name: "Apreciación Artística", semester: "Semestre III" },
    { name: "Apreciación Literaria", semester: "Semestre III" },
    { name: "Cálculo Financiero", semester: "Semestre IV" },
    { name: "Microeconomía", semester: "Semestre IV" },
    { name: "Teología I", semester: "Semestre IV" },
    { name: "Contabilidad de Sociedades", semester: "Semestre IV" },
    { name: "Contabilidad de Costos I", semester: "Semestre IV" },
    { name: "Normatividad Contable I", semester: "Semestre IV" },
    { name: "Administración General", semester: "Semestre IV" },
    { name: "Psicología", semester: "Semestre IV" },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre IV" },
    { name: "Estadística y Probabilidades", semester: "Semestre V" },
    { name: "Macroeconomía", semester: "Semestre V" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre V" },
    { name: "Moral", semester: "Semestre V" },
    { name: "Contabilidad de Costos II", semester: "Semestre V" },
    { name: "Legislación Tributaria", semester: "Semestre V" },
    { name: "Dirección Estratégica", semester: "Semestre V" },
    { name: "Teología II", semester: "Semestre VI" },
    { name: "Oratoria", semester: "Semestre VI" },
    { name: "Normatividad Contable II", semester: "Semestre VI" },
    { name: "Inferencia Estadística", semester: "Semestre VI" },
    { name: "Contabilidad Tributaria I", semester: "Semestre VI" },
    { name: "Presupuesto y Finanzas Públicas", semester: "Semestre VI" },
    {
      name: "Planeamiento y Control Presupuestario",
      semester: "Semestre VI",
    },
    { name: "Liderazgo", semester: "Semestre VII" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre VII",
    },
    { name: "Metodología de la Investigación", semester: "Semestre VII" },
    { name: "Contabilidad Tributaria II", semester: "Semestre VII" },
    {
      name: "Formulación, Análisis e Interpretación de los EE FF",
      semester: "Semestre VII",
    },
    { name: "Fundamentos de Auditoría", semester: "Semestre VII" },
    { name: "Contabilidad Gubernamental", semester: "Semestre VII" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre VIII" },
    {
      name: "Contabilidad de Costos Sectoriales",
      semester: "Semestre VIII",
    },
    {
      name: "Contabilidad Bancaria y de Seguros",
      semester: "Semestre VIII",
    },
    { name: "Auditoría Financiera", semester: "Semestre VIII" },
    { name: "Planeamiento Tributario", semester: "Semestre VIII" },
    {
      name: "Seminario de Investigación y Tesis I",
      semester: "Semestre VIII",
    },
    { name: "Finanzas Corporativas I", semester: "Semestre VIII" },
    {
      name: "Responsabilidad y Sanciones Fiscales",
      semester: "Semestre VIII",
    },
    { name: "Gestión de Riesgo en Seguros", semester: "Semestre VIII" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    { name: "Gabinete de Costos Industriales", semester: "Semestre IX" },
    { name: "Finanzas Corporativas II", semester: "Semestre IX" },
    { name: "Contabilidad Corporativa", semester: "Semestre IX" },
    { name: "Auditoría de Gestión Empresarial", semester: "Semestre IX" },
    { name: "Auditoría Tributaria", semester: "Semestre IX" },
    { name: "Tributación Internacional", semester: "Semestre IX" },
    { name: "Mercado de Capitales", semester: "Semestre IX" },
    { name: "Ética Profesional", semester: "Semestre X" },
    {
      name: "Seminario de Investigación y Tesis II",
      semester: "Semestre X",
    },
    { name: "Gabinete Contable", semester: "Semestre X" },
    { name: "Peritaje Contable y Judicial", semester: "Semestre X" },
    { name: "Auditoría Gubernamental", semester: "Semestre X" },
    {
      name: "Formulación y Evaluación de Proyectos",
      semester: "Semestre X",
    },
    { name: "Ingeniería Financiera", semester: "Semestre X" },
    { name: "Tributación Municipal y Laboral", semester: "Semestre X" },
  ],
  Derecho: [
    { name: "Comunicación I", semester: "Semestre I" },
    { name: "Introducción a la Filosofía", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Introducción al Estudio del Derecho", semester: "Semestre I" },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    { name: "Taller de Liderazgo", semester: "Semestre I" },
    { name: "Teatro", semester: "Semestre I" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre II",
    },
    { name: "Comunicación II", semester: "Semestre II" },
    {
      name: "Historia de la Cultura Occidental I",
      semester: "Semestre II",
    },
    { name: "Historia General del Derecho", semester: "Semestre II" },
    { name: "Retórica y Dialéctica", semester: "Semestre II" },
    { name: "Teoría del Derecho", semester: "Semestre II" },
    { name: "Apreciación Artística", semester: "Semestre II" },
    { name: "Apreciación Literaria", semester: "Semestre II" },
    {
      name: "Bases Romanistas del Derecho Contemporáneo",
      semester: "Semestre III",
    },
    { name: "Ciencia Política", semester: "Semestre III" },
    { name: "Derecho Natural", semester: "Semestre III" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre III",
    },
    { name: "Lógica y Gnoseología", semester: "Semestre III" },
    { name: "Matemática para abogados", semester: "Semestre III" },
    { name: "Apreciación Musical", semester: "Semestre III" },
    { name: "Sociología y Derecho", semester: "Semestre III" },
    { name: "Derecho Constitucional I", semester: "Semestre IV" },
    { name: "Derecho de Personas", semester: "Semestre IV" },
    { name: "Derecho Penal General", semester: "Semestre IV" },
    { name: "Derecho y Economía", semester: "Semestre IV" },
    { name: "Psicología", semester: "Semestre IV" },
    {
      name: "Sistema de Justicia y Mecanismos de Solución de Conflictos",
      semester: "Semestre IV",
    },
    { name: "Teología I", semester: "Semestre IV" },
    { name: "Acto Jurídico", semester: "Semestre V" },
    { name: "Derecho Administrativo I", semester: "Semestre V" },
    { name: "Derecho Constitucional II", semester: "Semestre V" },
    { name: "Derecho Penal Especial", semester: "Semestre V" },
    { name: "Derecho Procesal General", semester: "Semestre V" },
    {
      name: "Metodología de la Investigación Jurídica",
      semester: "Semestre V",
    },
    { name: "Moral", semester: "Semestre V" },
    { name: "Argumentación Jurídica", semester: "Semestre VI" },
    { name: "Derecho Administrativo II", semester: "Semestre VI" },
    { name: "Derecho Internacional Público", semester: "Semestre VI" },
    { name: "Derecho Procesal Civil I", semester: "Semestre VI" },
    { name: "Derechos Reales", semester: "Semestre VI" },
    { name: "Suficiencia de Mitad de Carrera", semester: "Semestre VI" },
    { name: "Teología II", semester: "Semestre VI" },
    {
      name:
        "Seminario de Derecho Penal: Derecho Penal Económico y Delitos contra la Administración Pública",
      semester: "Semestre VI",
    },
    {
      name: "Seminario de Introducción al Derecho Comparado",
      semester: "Semestre VI",
    },
    { name: "Historia de la Filosofía Política", semester: "Semestre VI" },
    {
      name: "Contabilidad y Análisis Financiero",
      semester: "Semestre VII",
    },
    { name: "Derecho de Obligaciones", semester: "Semestre VII" },
    { name: "Derecho Procesal Civil II", semester: "Semestre VII" },
    { name: "Derecho Procesal Constitucional", semester: "Semestre VII" },
    {
      name: "Derecho Tributario I: PP.GG. y Código Tributario",
      semester: "Semestre VII",
    },
    { name: "Historia del Perú I", semester: "Semestre VII" },
    { name: "Derecho Municipal y Regional", semester: "Semestre VII" },
    {
      name: "Derecho de la Propiedad Intelectual",
      semester: "Semestre VII",
    },
    {
      name: "Seminario de Organizaciones Internacionales",
      semester: "Semestre VII",
    },
    {
      name: "Derecho de Contratos I: Teoría General",
      semester: "Semestre VIII",
    },
    {
      name: "Derecho Laboral I: PP.GG. y D.L. Individual",
      semester: "Semestre VIII",
    },
    {
      name: "Derecho Mercantil I: Parte General y Titulos Valores",
      semester: "Semestre VIII",
    },
    { name: "Derecho Procesal Penal", semester: "Semestre VIII" },
    {
      name: "Derecho Tributario II: Impuesto a la Renta",
      semester: "Semestre VIII",
    },
    { name: "Historia del Perú II", semester: "Semestre VIII" },
    { name: "Derecho y Biotecnología", semester: "Semestre VIII" },
    {
      name: "Seminario de Criminalística, Ciencias Forenses y Criminología",
      semester: "Semestre VIII",
    },
    { name: "Derecho de la Integración", semester: "Semestre VIII" },
    {
      name: "Derecho de Contratos II: Contratos Típicos",
      semester: "Semestre IX",
    },
    {
      name: "Derecho Laboral II: D.L. Colectivo y D. Previsional",
      semester: "Semestre IX",
    },
    { name: "Derecho Mercantil II: Sociedades", semester: "Semestre IX" },
    {
      name:
        "Derecho Tributario III: Imposición al Consumo y Tributación Municipal",
      semester: "Semestre IX",
    },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    {
      name: "Taller de Negociación, Mediación y Conciliación",
      semester: "Semestre IX",
    },
    { name: "Derecho Procesal Laboral", semester: "Semestre IX" },
    {
      name: "Seminario de Derecho y Nuevas Tecnologías",
      semester: "Semestre IX",
    },
    { name: "Taller de Litigación Oral", semester: "Semestre IX" },
    { name: "Arbitraje", semester: "Semestre X" },
    { name: "Derecho de Familia", semester: "Semestre X" },
    { name: "Ética Profesional", semester: "Semestre X" },
    { name: "Filosofía del Derecho", semester: "Semestre X" },
    { name: "Responsabilidad Civil y Seguros", semester: "Semestre X" },
    {
      name: "Seminario de Investigación Jurídica I",
      semester: "Semestre X",
    },
    {
      name:
        "Seminario de Derecho del Consumidor, Publicidad Comercial y Protección del Crédito",
      semester: "Semestre X",
    },
    {
      name: "Derecho Aduanero y Comercio Internacional",
      semester: "Semestre X",
    },
    {
      name: "Seminario de Contratación Estatal y Asociaciones Público Privadas",
      semester: "Semestre X",
    },
    { name: "Contratos Modernos", semester: "Semestre XI" },
    { name: "Derecho de Sucesiones", semester: "Semestre XI" },
    { name: "Derechos Humanos", semester: "Semestre XI" },
    {
      name: "Elementos de Derecho Canónico y Eclesiástico del Estado",
      semester: "Semestre XI",
    },
    { name: "Financiamiento y garantías", semester: "Semestre XI" },
    {
      name: "Seminario de Investigación Jurídica II",
      semester: "Semestre XI",
    },
    { name: "Derecho Bancario", semester: "Semestre XI" },
    { name: "Derecho Minero", semester: "Semestre XI" },
    {
      name: "Derecho de la Competencia y Regulación",
      semester: "Semestre XI",
    },
    { name: "Derecho Internacional Privado", semester: "Semestre XII" },
    { name: "Derecho Notarial y Registral", semester: "Semestre XII" },
    { name: "Inglés Técnico Jurídico", semester: "Semestre XII" },
    {
      name:
        "Práctica Empresarial: Mercantil, Tributario, Laboral y Gestión Empresarial",
      semester: "Semestre XII",
    },
    { name: "Práctica Forense Civil y Penal", semester: "Semestre XII" },
    {
      name: "Arbitraje Comercial Internacional y de Inversiones",
      semester: "Semestre XII",
    },
    { name: "Derecho de la Energía", semester: "Semestre XII" },
    { name: "Dirección y Liderazgo Estratégico", semester: "Semestre XII" },
  ],
  "Educación Inicial": [
    { name: "Comunicación I", semester: "Semestre I" },
    {
      name: "Introducción a la vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática Básica", semester: "Semestre I" },
    { name: "Metodología de estudio", semester: "Semestre I" },
    {
      name: "Pediatría, salud, seguridad y nutrición infantil",
      semester: "Semestre I",
    },
    { name: "Práctica: Formación del Educador", semester: "Semestre I" },
    { name: "Psicología general", semester: "Semestre I" },
    { name: "Aprestamiento de la Comunicación I", semester: "Semestre II" },
    { name: "Aprestamiento de la Matemática I", semester: "Semestre II" },
    { name: "Comunicación II", semester: "Semestre II" },
    { name: "Familia, Educación y sexualidad", semester: "Semestre II" },
    {
      name: "Historia de la Cultura Occidental I",
      semester: "Semestre II",
    },
    { name: "Introducción a la filosofía", semester: "Semestre II" },
    { name: "Psicología del Desarrollo", semester: "Semestre II" },
    { name: "Taller de Educación Musical", semester: "Semestre II" },
    {
      name: "Antropología filosófica y teológica",
      semester: "Semestre III",
    },
    {
      name: "Aprestamiento de la Comunicación II",
      semester: "Semestre III",
    },
    { name: "Aprestamiento de la Matemática II", semester: "Semestre III" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre III",
    },
    { name: "Práctica de Observación I", semester: "Semestre III" },
    { name: "Psicología Educativa Infantil", semester: "Semestre III" },
    { name: "Tecnología I", semester: "Semestre III" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre IV" },
    {
      name: "Aprestamiento de la Comunicación III",
      semester: "Semestre IV",
    },
    { name: "Aprestamiento de la Matemática III", semester: "Semestre IV" },
    { name: "Estadística", semester: "Semestre IV" },
    { name: "Práctica de Observación II", semester: "Semestre IV" },
    { name: "Tecnología II", semester: "Semestre IV" },
    { name: "Teología I", semester: "Semestre IV" },
    {
      name: "Aprestamiento de la Ciencia y Ambiente",
      semester: "Semestre V",
    },
    { name: "Filosofía de la Educación", semester: "Semestre V" },
    { name: "Lógica y Gnoseología", semester: "Semestre V" },
    {
      name: "Metodología de la Investigación Cuantitativa",
      semester: "Semestre V",
    },
    { name: "Piscomotricidad", semester: "Semestre V" },
    { name: "Práctica de Ayudantía I", semester: "Semestre V" },
    { name: "Psicología del Aprendizaje", semester: "Semestre V" },
    { name: "Tecnología III", semester: "Semestre V" },
    {
      name: "Aprestamiento de las Ciencias Sociales",
      semester: "Semestre VI",
    },
    { name: "Historia de la Educación", semester: "Semestre VI" },
    {
      name: "Metodología de la Investigación Cualitativa",
      semester: "Semestre VI",
    },
    { name: "Moral", semester: "Semestre VI" },
    {
      name: "Orientación, Tutoría, Acompañamiento y Consejería",
      semester: "Semestre VI",
    },
    { name: "Práctica de Ayudantía II", semester: "Semestre VI" },
    { name: "Tecnología IV", semester: "Semestre VI" },
    {
      name: "Taller de Oratoria, Liderazgo y Coaching",
      semester: "Semestre VI",
    },
    { name: "Aprestamiento de las Artes", semester: "Semestre VII" },
    { name: "Epistemología de la Educación", semester: "Semestre VII" },
    {
      name: "Gestión de Instituciones Educativas",
      semester: "Semestre VII",
    },
    { name: "Práctica Discontinua I", semester: "Semestre VII" },
    { name: "Taller de Investigación I", semester: "Semestre VII" },
    { name: "Teología II", semester: "Semestre VII" },
    { name: "TICs I", semester: "Semestre VII" },
    { name: "Enseñanza social de la Iglesia", semester: "Semestre VIII" },
    { name: "Práctica Discontinua II", semester: "Semestre VIII" },
    {
      name: "Problemas de aprendizaje y educación inclusiva",
      semester: "Semestre VIII",
    },
    {
      name: "Proyectos Educativos y de Innovación",
      semester: "Semestre VIII",
    },
    { name: "Sociología de la Educación", semester: "Semestre VIII" },
    { name: "Taller de Investigación II", semester: "Semestre VIII" },
    { name: "TICs II", semester: "Semestre VIII" },
    {
      name: "Administración y Legislación Educativa",
      semester: "Semestre IX",
    },
    { name: "Ética profesional", semester: "Semestre IX" },
    { name: "Práctica Continua I", semester: "Semestre IX" },
    { name: "Seminario de tesis I", semester: "Semestre IX" },
    { name: "Emprendimiento en Educación", semester: "Semestre IX" },
    { name: "Persona, Matrimonio y familia", semester: "Semestre IX" },
    { name: "Práctica Continua II", semester: "Semestre X" },
    { name: "Seminario de Actualidad Educativa", semester: "Semestre X" },
    { name: "Seminario de tesis II", semester: "Semestre X" },
    { name: "Taller de Artes Plásticas", semester: "Semestre X" },
    { name: "Taller de Teatro", semester: "Semestre X" },
  ],
  "Educación Primaria": [
    { name: "Comunicación I", semester: "Semestre I" },
    {
      name: "Introducción a la vida universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática Básica", semester: "Semestre I" },
    { name: "Metodología del estudio", semester: "Semestre I" },
    {
      name: "Pediatría, salud, seguridad y nutrición infantil",
      semester: "Semestre I",
    },
    { name: "Práctica: Formación del Educador", semester: "Semestre I" },
    { name: "Psicología General", semester: "Semestre I" },
    { name: "Comunicación II", semester: "Semestre II" },
    { name: "Didáctica de la Comunicación I", semester: "Semestre II" },
    { name: "Didáctica de la Matemática I", semester: "Semestre II" },
    { name: "Familia, Educación y sexualidad", semester: "Semestre II" },
    {
      name: "Historia de la Cultura Occidental I",
      semester: "Semestre II",
    },
    { name: "Introducción a la filosofía", semester: "Semestre II" },
    { name: "Psicología del Desarrollo", semester: "Semestre II" },
    { name: "Taller de Educación Musical", semester: "Semestre II" },
    {
      name: "Antropología filosófica y teológica",
      semester: "Semestre III",
    },
    { name: "Didáctica de la Comunicación II", semester: "Semestre III" },
    { name: "Didáctica de la Matemática II", semester: "Semestre III" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre III",
    },
    { name: "Práctica de Observación I", semester: "Semestre III" },
    { name: "Psicología Educativa Infantil", semester: "Semestre III" },
    { name: "Tecnología I", semester: "Semestre III" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre IV" },
    { name: "Didáctica de la Comunicación III", semester: "Semestre IV" },
    { name: "Didáctica de la Matemática III", semester: "Semestre IV" },
    { name: "Estadística", semester: "Semestre IV" },
    { name: "Práctica de Observación II", semester: "Semestre IV" },
    { name: "Tecnología II", semester: "Semestre IV" },
    { name: "Teología I", semester: "Semestre IV" },
    { name: "Lógica y gnoseología", semester: "Semestre V" },
    {
      name: "Metodología de la investigación cuantitativa",
      semester: "Semestre V",
    },
    { name: "Práctica de Ayudantía I", semester: "Semestre V" },
    { name: "Tecnología III", semester: "Semestre V" },
    { name: "Didáctica de Ciencia y Ambiente", semester: "Semestre V" },
    { name: "Educación Física", semester: "Semestre V" },
    { name: "Psicología del Aprendizaje", semester: "Semestre V" },
    { name: "Filosofía de la Educación", semester: "Semestre V" },
    { name: "Didáctica de las Ciencias Sociales", semester: "Semestre VI" },
    { name: "Historia de la Educación", semester: "Semestre VI" },
    {
      name: "Metodología de la investigación cualitativa",
      semester: "Semestre VI",
    },
    { name: "Moral", semester: "Semestre VI" },
    {
      name: "Orientación, tutoría, acompañamiento y consejería",
      semester: "Semestre VI",
    },
    { name: "Práctica de Ayudantía II", semester: "Semestre VI" },
    {
      name: "Taller de Oratoria, Liderazgo y Coaching",
      semester: "Semestre VI",
    },
    { name: "Tecnología IV", semester: "Semestre VII" },
    { name: "Didáctica de las Artes", semester: "Semestre VII" },
    { name: "Epistemología de la Educación", semester: "Semestre VII" },
    {
      name: "Gestión de Instituciones Educativas",
      semester: "Semestre VII",
    },
    { name: "Práctica Discontinua I", semester: "Semestre VII" },
    { name: "Taller de Investigación I", semester: "Semestre VII" },
    { name: "Teología II", semester: "Semestre VII" },
    { name: "TICs I", semester: "Semestre VII" },
    { name: "Enseñanza social de la Iglesia", semester: "Semestre VIII" },
    { name: "Práctica Discontinua II", semester: "Semestre VIII" },
    {
      name: "Problemas de aprendizaje y educación inclusiva",
      semester: "Semestre VIII",
    },
    {
      name: "Proyectos Educativos y de Innovación",
      semester: "Semestre VIII",
    },
    { name: "Sociología de la Educación", semester: "Semestre VIII" },
    { name: "Taller de Investigación II", semester: "Semestre VIII" },
    { name: "TICs II", semester: "Semestre VIII" },
    {
      name: "Administración y Legislación Educativa",
      semester: "Semestre IX",
    },
    { name: "Ética profesional", semester: "Semestre IX" },
    { name: "Práctica Continua I", semester: "Semestre IX" },
    { name: "Seminario de tesis I", semester: "Semestre IX" },
    { name: "Emprendimiento en Educación", semester: "Semestre IX" },
    { name: "Persona, Matrimonio y familia", semester: "Semestre IX" },
    { name: "Seminario de tesis II", semester: "Semestre X" },
    { name: "Práctica Continua II", semester: "Semestre X" },
    { name: "Seminario de Actualidad Educativa", semester: "Semestre X" },
    { name: "Taller de Teatro", semester: "Semestre X" },
    { name: "Taller de Artes Plásticas", semester: "Semestre X" },
  ],
  "Ingeniería Ambiental": [
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre I" },
    {
      name: "Introducción a la Ingeniería Ambiental",
      semester: "Semestre I",
    },
    { name: "Matemática I", semester: "Semestre I" },
    {
      name: "Metodología del Estudio e Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Química I", semester: "Semestre I" },
    { name: "Biología y Ecosistemas", semester: "Semestre I" },
    {
      name: "Dibujo Técnico y Geometría Descriptiva",
      semester: "Semestre II",
    },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre II",
    },
    { name: "Economía General y Ambiental", semester: "Semestre III" },
    { name: "Introducción a la Filosofía", semester: "Semestre III" },
    { name: "Química Ambiental I", semester: "Semestre III" },
    {
      name: "Ciencia y Tecnología de los Materiales",
      semester: "Semestre IV",
    },
    { name: "Estadística II", semester: "Semestre IV" },
    { name: "Filosofía de la Naturaleza", semester: "Semestre IV" },
    { name: "Física II", semester: "Semestre IV" },
    { name: "Microbiología Ambiental", semester: "Semestre IV" },
    { name: "Química Ambiental II", semester: "Semestre IV" },
    { name: "Antropología Filosófica y Teológica", semester: "Semestre V" },
    { name: "Apreciación Artística", semester: "Semestre V" },
    { name: "Apreciación Literaria", semester: "Semestre V" },
    { name: "Apreciación Musical", semester: "Semestre V" },
    { name: "Balance de Materia y Energía", semester: "Semestre V" },
    { name: "Fenómenos de Transporte I", semester: "Semestre V" },
    {
      name: "Fundamentos de Programación y Sistemas",
      semester: "Semestre V",
    },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre V" },
    { name: "Seminario de Investigación", semester: "Semestre V" },
    { name: "Teatro", semester: "Semestre V" },
    { name: "Termodinámica", semester: "Semestre V" },
    {
      name: "Contaminación y Monitoreo Ambiental",
      semester: "Semestre VI",
    },
    {
      name: "Energías Renovables y Medio Ambiente",
      semester: "Semestre VI",
    },
    { name: "Fenómenos de Transporte II", semester: "Semestre VI" },
    { name: "Geología y Topografía", semester: "Semestre VI" },
    { name: "Mecánica de Fluidos", semester: "Semestre VI" },
    { name: "Metafísica", semester: "Semestre VI" },
    { name: "Calidad del Aire", semester: "Semestre VII" },
    { name: "Edafología y Geotelemática", semester: "Semestre VII" },
    { name: "Hidrología Ambiental", semester: "Semestre VII" },
    { name: "Meteorología y Climatología", semester: "Semestre VII" },
    { name: "Moral", semester: "Semestre VII" },
    {
      name: "Responsabilidad Social y Ambiental",
      semester: "Semestre VII",
    },
    { name: "Salud Ambiental", semester: "Semestre VII" },
    {
      name: "Desarrollo y Dirección de Proyectos Ambientales",
      semester: "Semestre VIII",
    },
    { name: "Gestión de Cuencas Hidrográficas", semester: "Semestre VIII" },
    { name: "Gestión de Residuos Sólidos", semester: "Semestre VIII" },
    { name: "Legislación Ambiental Nacional", semester: "Semestre VIII" },
    {
      name: "Procesos de Tratamiento físico-químico de Efluentes",
      semester: "Semestre VIII",
    },
    {
      name: "Remediación de Suelos y Áreas Contaminadas",
      semester: "Semestre VIII",
    },
    { name: "Teología", semester: "Semestre VIII" },
    {
      name: "Tratamiento de Aguas Residuales y Efluentes",
      semester: "Semestre VIII",
    },
    {
      name: "Desarrollo Urbano y Territorial Sostenible",
      semester: "Semestre IX",
    },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    { name: "Evaluación de Impacto Ambiental", semester: "Semestre IX" },
    {
      name: "Gestión de Desastres y Conflictos Ambientales",
      semester: "Semestre IX",
    },
    { name: "Minería y Ambiente", semester: "Semestre IX" },
    { name: "Seguridad y Salud Ocupacional", semester: "Semestre IX" },
    { name: "Taller de Investigación I", semester: "Semestre IX" },
    { name: "Tratamiento de Agua Natural", semester: "Semestre IX" },
    {
      name: "Análisis de Ciclo de Vida y Sistemas Integrados de Gestión",
      semester: "Semestre X",
    },
    { name: "Derecho Ambiental Internacional", semester: "Semestre X" },
    {
      name: "Diseño de Sistemas de Ingeniería Ambiental",
      semester: "Semestre X",
    },
    { name: "Ética Profesional", semester: "Semestre X" },
    { name: "Gestión Ambiental Costera", semester: "Semestre X" },
    {
      name: "Procesos de Tratamiento Biológico de Efluentes",
      semester: "Semestre X",
    },
    { name: "Taller de Investigación II", semester: "Semestre X" },
  ],
  "Ingeniería Civil": [
    { name: "Álgebra y Geometría", semester: "Semestre I" },
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Informática y Programación", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática Básica", semester: "Semestre I" },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    { name: "Química", semester: "Semestre I" },
    { name: "Álgebra Lineal", semester: "Semestre II" },
    { name: "Cálculo en Una Variable", semester: "Semestre II" },
    { name: "Dibujo Técnico y CAD", semester: "Semestre II" },
    { name: "Física I", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre II" },
    { name: "Topografía I", semester: "Semestre II" },
    { name: "Liderazgo", semester: "Semestre II" },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre II" },
    { name: "Teatro", semester: "Semestre II" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre III",
    },
    { name: "Cálculo en Varias Variables", semester: "Semestre III" },
    { name: "Estática", semester: "Semestre III" },
    { name: "Física II", semester: "Semestre III" },
    { name: "Geología General", semester: "Semestre III" },
    { name: "Topografía II", semester: "Semestre III" },
    { name: "Apreciación Literaria", semester: "Semestre III" },
    { name: "Apreciación Musical", semester: "Semestre III" },
    { name: "Artes Plásticas", semester: "Semestre III" },
    { name: "Dinámica", semester: "Semestre IV" },
    { name: "Ecuaciones Diferenciales", semester: "Semestre IV" },
    { name: "Estadística y Probabilidades", semester: "Semestre IV" },
    { name: "Lógica y Gnoseología", semester: "Semestre IV" },
    {
      name: "Tecnología de los Materiales de Construcción",
      semester: "Semestre IV",
    },
    { name: "Teología", semester: "Semestre IV" },
    { name: "Arquitectura y Urbanismo", semester: "Semestre V" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre V" },
    { name: "Mecánica de Fluidos", semester: "Semestre V" },
    { name: "Mecánica de Materiales I", semester: "Semestre V" },
    { name: "Mecánica de Suelos I", semester: "Semestre V" },
    { name: "Tecnología del Concreto", semester: "Semestre V" },
    { name: "Construcción I", semester: "Semestre VI" },
    {
      name: "Fundamentos de la Ingeniería Ambiental",
      semester: "Semestre VI",
    },
    { name: "Hidráulica", semester: "Semestre VI" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre VI",
    },
    { name: "Mecánica de Materiales II", semester: "Semestre VI" },
    { name: "Mecánica de Suelos II", semester: "Semestre VI" },
    { name: "Moral", semester: "Semestre VI" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre VII" },
    { name: "Análisis Estructural I", semester: "Semestre VII" },
    { name: "Caminos I", semester: "Semestre VII" },
    { name: "Concreto Armado I", semester: "Semestre VII" },
    { name: "Construcción II", semester: "Semestre VII" },
    { name: "Hidrología", semester: "Semestre VII" },
    { name: "Instalaciones en Edificaciones", semester: "Semestre VII" },
    {
      name: "Abastecimiento de Agua y Alcantarillado",
      semester: "Semestre VIII",
    },
    { name: "Análisis Estructural II", semester: "Semestre VIII" },
    { name: "Caminos II", semester: "Semestre VIII" },
    { name: "Concreto Armado II", semester: "Semestre VIII" },
    { name: "Costos y Presupuestos", semester: "Semestre VIII" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre VIII" },
    {
      name: "Estructuras Metálicas y Compuestas",
      semester: "Semestre VIII",
    },
    { name: "Albañilería Estructural", semester: "Semestre IX" },
    { name: "Ética Profesional", semester: "Semestre IX" },
    { name: "Ingeniería de Tránsito", semester: "Semestre IX" },
    { name: "Ingeniería Sísmica", semester: "Semestre IX" },
    {
      name: "Metodología de la Investigación Científica",
      semester: "Semestre IX",
    },
    {
      name: "Planificación y Control en la Construcción",
      semester: "Semestre IX",
    },
    { name: "Concreto Preforzado", semester: "Semestre IX" },
    {
      name: "Estructuras de Madera y Materiales Alternativos",
      semester: "Semestre IX",
    },
    { name: "Gestión de Seguridad y Salud", semester: "Semestre IX" },
    { name: "Irrigaciones", semester: "Semestre IX" },
    { name: "Mecánica de Rocas", semester: "Semestre IX" },
    { name: "Método de los Elementos Finitos", semester: "Semestre IX" },
    { name: "Seguridad y Operación Vial", semester: "Semestre IX" },
    { name: "Gestión de la Construcción", semester: "Semestre X" },
    { name: "Ingeniería de Cimentaciones", semester: "Semestre X" },
    {
      name: "Modelamiento Informático en Edificaciones",
      semester: "Semestre X",
    },
    { name: "Productividad en la Construcción", semester: "Semestre X" },
    { name: "Proyecto de Tesis", semester: "Semestre X" },
    { name: "Edificaciones Inteligentes y Green", semester: "Semestre X" },
    { name: "Estructuras Hidráulicas", semester: "Semestre X" },
    { name: "Gestión de Empresas Inmobiliarias", semester: "Semestre X" },
    {
      name: "Gestión de Infraestructura ante Riesgos Naturales",
      semester: "Semestre X",
    },
    { name: "Ingeniería Vial Pluvial y Marítima", semester: "Semestre X" },
    { name: "Ingeniería Vial Terrestre y Aérea", semester: "Semestre X" },
    { name: "Pavimentos", semester: "Semestre X" },
    { name: "Puentes y Grandes Estructuras", semester: "Semestre X" },
    { name: "Recursos Hídricos", semester: "Semestre X" },
  ],
  "Ingeniería Electrónica y Telecomunicaciones": [
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Matemática", semester: "Semestre I" },
    { name: "Introducción a la Ingeniería", semester: "Semestre I" },
    { name: "Álgebra y Geometría", semester: "Semestre I" },
    { name: "Programación I", semester: "Semestre I" },
    { name: "Física I", semester: "Semestre II" },
    { name: "Cálculo en Una Variable", semester: "Semestre II" },
    { name: "Álgebra Lineal", semester: "Semestre II" },
    { name: "Programación II", semester: "Semestre II" },
    { name: "Circuitos Eléctricos", semester: "Semestre II" },
    { name: "Apreciación Artística", semester: "Semestre II" },
    { name: "Apreciación Literaria", semester: "Semestre II" },
    { name: "Apreciación Musical", semester: "Semestre II" },
    { name: "Teatro", semester: "Semestre II" },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre II" },
    { name: "Liderazgo", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre III" },
    { name: "Ecuaciones Diferenciales", semester: "Semestre III" },
    { name: "Física II", semester: "Semestre III" },
    { name: "Cálculo en Varias Variables", semester: "Semestre III" },
    { name: "Electrónica Digital", semester: "Semestre III" },
    { name: "Circuitos Electrónicos", semester: "Semestre III" },
    { name: "Arquitectura de Computadoras", semester: "Semestre IV" },
    { name: "Señales y Sistemas", semester: "Semestre IV" },
    { name: "Redes de Acceso y Medio Compartido", semester: "Semestre IV" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre IV",
    },
    { name: "Probabilidad y Variable Aleatoria", semester: "Semestre IV" },
    { name: "Campos Electromagnéticos", semester: "Semestre IV" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre V" },
    { name: "Sistemas Lineales", semester: "Semestre V" },
    { name: "Tratamiento de la Información", semester: "Semestre V" },
    { name: "Lógica y Gnoseología", semester: "Semestre V" },
    { name: "Electrónica Industrial", semester: "Semestre V" },
    {
      name: "Microprocesadores y Microcontroladores",
      semester: "Semestre V",
    },
    { name: "Electrónica de Comunicaciones", semester: "Semestre VI" },
    { name: "Redes de Ordenadores", semester: "Semestre VI" },
    { name: "Tratamiento Digital de Señales", semester: "Semestre VI" },
    { name: "Teología I", semester: "Semestre VI" },
    { name: "Comunicaciones Digitales", semester: "Semestre VI" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre VI",
    },
    { name: "Alta Frecuencia", semester: "Semestre VII" },
    { name: "Sistemas de Telecomunicaciones", semester: "Semestre VII" },
    { name: "Tratamiento de Señales Multimedia", semester: "Semestre VII" },
    { name: "Sistemas de Control", semester: "Semestre VII" },
    { name: "Moral", semester: "Semestre VII" },
    {
      name: "Regulación y Política de Telecomunicaciones",
      semester: "Semestre VII",
    },
    { name: "Antenas y Propagación", semester: "Semestre VIII" },
    {
      name: "Aplicaciones y Servicios de Redes",
      semester: "Semestre VIII",
    },
    { name: "Comunicaciones Inalámbricas", semester: "Semestre VIII" },
    { name: "Metodología de la Investigación", semester: "Semestre VIII" },
    { name: "Sistemas Optoelectrónicos", semester: "Semestre VIII" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre VIII" },
    {
      name: "Introducción al Aprendizaje Máquina",
      semester: "Semestre IX",
    },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    {
      name: "Conmutación, Planificación y Gestión de Redes",
      semester: "Semestre IX",
    },
    { name: "Control y Automatización", semester: "Semestre IX" },
    {
      name: "Comunicaciones Móviles y Satelitales",
      semester: "Semestre IX",
    },
    { name: "Proyecto de Tesis I", semester: "Semestre IX" },
    { name: "Comunicaciones Industriales", semester: "Semestre X" },
    { name: "Ética Profesional", semester: "Semestre X" },
    {
      name: "El Negocio de Empresas de Base Tecnológica",
      semester: "Semestre X",
    },
    {
      name: "Sistemas Operativos, Distribuidos y Servidores",
      semester: "Semestre X",
    },
    { name: "Enertrónica", semester: "Semestre X" },
    { name: "Tratamiento de Datos", semester: "Semestre X" },
    { name: "Robótica", semester: "Semestre X" },
    { name: "Economía y Proyectos", semester: "Semestre X" },
    { name: "Proyecto de Tesis II", semester: "Semestre X" },
    {
      name: "Aplicaciones de Ingeniería Biomédicas",
      semester: "Semestre X",
    },
  ],
  "Ingeniería Industrial": [
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Química I", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática I", semester: "Semestre I" },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    {
      name: "Dibujo Técnico y Geometría Descriptiva",
      semester: "Semestre I",
    },
    { name: "Matemática II", semester: "Semestre II" },
    { name: "Cálculo I", semester: "Semestre II" },
    { name: "Física I", semester: "Semestre II" },
    { name: "Fundamentos de Informática", semester: "Semestre II" },
    { name: "Introducción a la Filosofía", semester: "Semestre II" },
    { name: "Química II", semester: "Semestre II" },
    { name: "Economía General", semester: "Semestre III" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre III",
    },
    { name: "Cálculo II", semester: "Semestre III" },
    {
      name: "Metodología de la Investigación Científica",
      semester: "Semestre III",
    },
    { name: "Física II", semester: "Semestre III" },
    { name: "Lógica y Gnoseología", semester: "Semestre III" },
    { name: "Organización Métodos", semester: "Semestre III" },
    {
      name: "Sistemas y Tecnologías de la Información",
      semester: "Semestre III",
    },
    { name: "Termodinámica", semester: "Semestre IV" },
    { name: "Ingeniería Económica", semester: "Semestre IV" },
    { name: "Estadística I", semester: "Semestre IV" },
    { name: "Teología I", semester: "Semestre IV" },
    { name: "Dibujo Técnico Avanzado", semester: "Semestre IV" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre V" },
    { name: "Mecánica para Ingenieros", semester: "Semestre V" },
    { name: "Investigación de Operaciones I", semester: "Semestre V" },
    { name: "Ingeniería de Métodos", semester: "Semestre V" },
    { name: "Estadística II", semester: "Semestre V" },
    { name: "Fundamentos de Marketing", semester: "Semestre V" },
    { name: "Investigación de Operaciones II", semester: "Semestre VI" },
    { name: "Ingeniería de Materiales", semester: "Semestre VI" },
    { name: "Artes Plásticas", semester: "Semestre VI" },
    { name: "Apreciación Literaria", semester: "Semestre VI" },
    { name: "Apreciación Musical", semester: "Semestre VI" },
    { name: "Teatro", semester: "Semestre VI" },
    { name: "Persona Matrimonio y Familia", semester: "Semestre VI" },
    { name: "Procesos Industriales", semester: "Semestre VI" },
    { name: "Costos y Presupuestos", semester: "Semestre VI" },
    { name: "Investigación de Mercados", semester: "Semestre VI" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre VI",
    },
    { name: "Electricidad Industrial", semester: "Semestre VII" },
    { name: "Control Integral de Calidad", semester: "Semestre VII" },
    { name: "Moral", semester: "Semestre VII" },
    { name: "Logística I", semester: "Semestre VII" },
    { name: "Seguridad y Salud en el trabajo", semester: "Semestre VII" },
    { name: "Modelamiento de Procesos", semester: "Semestre VII" },
    { name: "Innovación y Emprendimiento", semester: "Semestre VIII" },
    { name: "Ergonomía y Antropometría", semester: "Semestre VIII" },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre VIII" },
    { name: "Sistema de Mejora de Procesos", semester: "Semestre VIII" },
    { name: "Logística II", semester: "Semestre VIII" },
    { name: "Simulación de Sistemas", semester: "Semestre VIII" },
    { name: "Gestión del Medio Ambiente", semester: "Semestre VIII" },
    { name: "Ingles Técnico", semester: "Semestre VIII" },
    { name: "Diseño de Planta", semester: "Semestre VIII" },
    { name: "Gestión de Desarrollo Humano", semester: "Semestre IX" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    { name: "Automatización Industrial", semester: "Semestre IX" },
    { name: "Dirección Financiera", semester: "Semestre IX" },
    {
      name: "Planeamiento y Control de Operaciones",
      semester: "Semestre IX",
    },
    { name: "Taller de Investigación I", semester: "Semestre IX" },
    {
      name: "Gestión de Operaciones en Servicios",
      semester: "Semestre IX",
    },
    { name: "Dirección Estratégica", semester: "Semestre X" },
    { name: "Ética Profesional", semester: "Semestre X" },
    {
      name: "Gestión de la Calidad de Productos y Procesos",
      semester: "Semestre X",
    },
    { name: "Formulación Evaluación de Proyectos", semester: "Semestre X" },
    { name: "Taller de Investigación II", semester: "Semestre X" },
    { name: "Legislación Laboral y Empresarial", semester: "Semestre X" },
    { name: "Gestión de Mantenimiento", semester: "Semestre X" },
    { name: "Negocios Internacionales", semester: "Semestre X" },
    { name: "Gestión de la Innovación", semester: "Semestre X" },
    { name: "Gestión de Proyectos con PMBok", semester: "Semestre X" },
    { name: "Lean Manufacturing", semester: "Semestre X" },
    { name: "Inteligencia de Negocios", semester: "Semestre X" },
    { name: "Comportamiento Organizacional", semester: "Semestre X" },
    { name: "Gerencia", semester: "Semestre X" },
    { name: "Supply Chain Management", semester: "Semestre X" },
  ],
  "Ingeniería Mecatrónica": [
    { name: "Comunicación", semester: "Semestre I" },
    { name: "Introducción a la Ingeniería", semester: "Semestre I" },
    { name: "Matemática", semester: "Semestre I" },
    {
      name: "Metodología del Estudio e Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Programación I", semester: "Semestre I" },
    { name: "Química General", semester: "Semestre I" },
    { name: "Álgebra Lineal", semester: "Semestre II" },
    { name: "Cálculo en una Variable", semester: "Semestre II" },
    { name: "Diseño Asistido por Computador", semester: "Semestre II" },
    { name: "Física I", semester: "Semestre II" },
    {
      name: "Historia de la Cultura Occidental I",
      semester: "Semestre II",
    },
    { name: "Programación II", semester: "Semestre II" },
    { name: "Cálculo en Varias Variables", semester: "Semestre III" },
    {
      name: "Circuitos Eléctricos y Electrónicos",
      semester: "Semestre III",
    },
    { name: "Electrónica Digital", semester: "Semestre III" },
    { name: "Física II", semester: "Semestre III" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre III",
    },
    { name: "Probabilidad y Variable Aleatoria", semester: "Semestre III" },
    { name: "Análisis de Señales y Sistemas", semester: "Semestre IV" },
    { name: "Ecuaciones Diferenciales", semester: "Semestre IV" },
    { name: "Estática", semester: "Semestre IV" },
    { name: "Introducción a la Filosofía", semester: "Semestre IV" },
    { name: "Introducción a Sistemas Embebidos", semester: "Semestre IV" },
    { name: "Proyecto de Ingeniería", semester: "Semestre IV" },
    {
      name: "Ciencias y Mecánica de los Materiales",
      semester: "Semestre V",
    },
    { name: "Dinámica", semester: "Semestre V" },
    {
      name: "Diseño de Sistemas Analógicos y Digitales",
      semester: "Semestre V",
    },
    { name: "Ingeniería Asistida por Computador", semester: "Semestre V" },
    { name: "Lógica y Gnoseología", semester: "Semestre V" },
    { name: "Modelamiento de Sistemas Dinámicos", semester: "Semestre V" },
    {
      name: "Antropología Filosófica y Teológica",
      semester: "Semestre VI",
    },
    { name: "Control Automático", semester: "Semestre VI" },
    { name: "Innovación y Diseño del Producto", semester: "Semestre VI" },
    {
      name: "Mecanismos y Transmisión de Movimientos",
      semester: "Semestre VI",
    },
    { name: "Procesamiento Digital de Señales", semester: "Semestre VI" },
    { name: "Termodinámica", semester: "Semestre VI" },
    { name: "Control de Procesos", semester: "Semestre VII" },
    { name: "Filosofía de la Ciencia", semester: "Semestre VII" },
    { name: "Ingeniería de Termofluidos", semester: "Semestre VII" },
    {
      name: "Introducción al Aprendizaje Máquina",
      semester: "Semestre VII",
    },
    {
      name: "Máquinas Eléctricas y Electrónica de Potencia",
      semester: "Semestre VII",
    },
    { name: "Proyecto Integrador", semester: "Semestre VII" },
    { name: "Apreciación Artística", semester: "Semestre VIII" },
    { name: "Apreciación Literaria", semester: "Semestre VIII" },
    { name: "Apreciación Musical", semester: "Semestre VIII" },
    {
      name: "Control de Manipuladores Robóticos",
      semester: "Semestre VIII",
    },
    { name: "Liderazgo", semester: "Semestre VIII" },
    { name: "Metodología de la Investigación", semester: "Semestre VIII" },
    { name: "Persona, Matrimonio y Familia", semester: "Semestre VIII" },
    { name: "Procesos de Fabricación", semester: "Semestre VIII" },
    {
      name: "Sistemas Electrohidráulicos y Electroneumáticos",
      semester: "Semestre VIII",
    },
    { name: "Teatro", semester: "Semestre VIII" },
    { name: "Teología I", semester: "Semestre VIII" },
    {
      name: "Aplicaciones de Ingeniería Biomédica",
      semester: "Semestre IX",
    },
    {
      name: "Fundamentos de Automatización Industrial",
      semester: "Semestre IX",
    },
    { name: "Moral", semester: "Semestre IX" },
    { name: "Proyecto de Tesis I", semester: "Semestre IX" },
    { name: "Robótica Móvil", semester: "Semestre IX" },
    { name: "Sistemas Aeroespaciales", semester: "Semestre IX" },
    { name: "Sistemas de Control Avanzado", semester: "Semestre IX" },
    { name: "Sistemas Eléctricos de Potencia", semester: "Semestre IX" },
    {
      name: "Emprendimiento, Gestión y Dirección de Empresas",
      semester: "Semestre X",
    },
    { name: "Enertrónica", semester: "Semestre X" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre X" },
    { name: "Ética Profesional", semester: "Semestre X" },
    {
      name: "Legislación, Seguridad y Gestión Ambiental",
      semester: "Semestre X",
    },
    { name: "Proyecto de Tesis II", semester: "Semestre X" },
    {
      name: "Sistemas Operativos Distribuidos y Servidores",
      semester: "Semestre X",
    },
    { name: "Visión Computacional", semester: "Semestre X" },
  ],
  Psicología: [
    { name: "Comunicación I", semester: "Semestre I" },
    { name: "Historia de la Psicología I", semester: "Semestre I" },
    { name: "Introducción a la Filosofía", semester: "Semestre I" },
    {
      name: "Introducción a la Vida Universitaria",
      semester: "Semestre I",
    },
    { name: "Matemática Básica", semester: "Semestre I" },
    { name: "Metodología del Estudio", semester: "Semestre I" },
    { name: "Psicología General I", semester: "Semestre I" },
    {
      name: "Antropología Filosófica y Teológica I",
      semester: "Semestre II",
    },
    { name: "Comunicación II", semester: "Semestre II" },
    { name: "Historia de la Psicología II", semester: "Semestre II" },
    { name: "Introducción a la Biología Humana", semester: "Semestre II" },
    { name: "Psicoestadística", semester: "Semestre II" },
    { name: "Psicología General II", semester: "Semestre II" },
    { name: "Música", semester: "Semestre II" },
    { name: "Familia", semester: "Semestre II" },
    { name: "Teatro", semester: "Semestre II" },
    {
      name: "Antropología Filosófica y Teológica II",
      semester: "Semestre III",
    },
    { name: "Lógica y Gnoseología", semester: "Semestre III" },
    { name: "Personalidad I", semester: "Semestre III" },
    { name: "Psicología del Desarrollo I", semester: "Semestre III" },
    { name: "Psicología Fisiológica", semester: "Semestre III" },
    { name: "Teología I", semester: "Semestre III" },
    { name: "Apreciación Literaria", semester: "Semestre III" },
    { name: "Artes Plásticas", semester: "Semestre III" },
    {
      name: "Corrientes de Psicología Contemporánea",
      semester: "Semestre IV",
    },
    { name: "Personalidad II", semester: "Semestre IV" },
    { name: "Psicología Cognitiva", semester: "Semestre IV" },
    { name: "Psicología del Desarrollo II", semester: "Semestre IV" },
    { name: "Psicometría", semester: "Semestre IV" },
    { name: "Teología II", semester: "Semestre IV" },
    { name: "Oratoria", semester: "Semestre IV" },
    { name: "Evaluación Psicológica I", semester: "Semestre V" },
    { name: "Historia de la Cultura Occidental I", semester: "Semestre V" },
    { name: "Metafísica", semester: "Semestre V" },
    {
      name: "Metodología de la Investigación Científica",
      semester: "Semestre V",
    },
    { name: "Psicología de la Educación", semester: "Semestre V" },
    { name: "Psicología de la Familia", semester: "Semestre V" },
    { name: "Psicopatología I", semester: "Semestre V" },
    { name: "Evaluación Psicológica II", semester: "Semestre VI" },
    {
      name: "Historia de la Cultura Occidental II",
      semester: "Semestre VI",
    },
    { name: "Moral", semester: "Semestre VI" },
    { name: "Psicofarmacología", semester: "Semestre VI" },
    { name: "Psicología Organizacional I", semester: "Semestre VI" },
    { name: "Psicopatología II", semester: "Semestre VI" },
    { name: "Teorías del Aprendizaje", semester: "Semestre VI" },
    { name: "Corrientes de Psicoterapia", semester: "Semestre VII" },
    {
      name: "Dificultades y Trastornos de Aprendizaje",
      semester: "Semestre VII",
    },
    { name: "Psicodiagnóstico", semester: "Semestre VII" },
    { name: "Psicología Clínica I", semester: "Semestre VII" },
    { name: "Psicología Organizacional II", semester: "Semestre VII" },
    { name: "Psicología Social", semester: "Semestre VII" },
    {
      name: "Teología III (Cristología - Teología de la gracia - Sacramentos)",
      semester: "Semestre VII",
    },
    { name: "Intervención Psicoeducativa", semester: "Semestre VIII" },
    {
      name: "Orientación Vocacional y Profesional",
      semester: "Semestre VIII",
    },
    { name: "Psicología Clínica II", semester: "Semestre VIII" },
    { name: "Psicología Organizacional III", semester: "Semestre VIII" },
    { name: "Psicopatología III", semester: "Semestre VIII" },
    { name: "Seminario de Tesis I", semester: "Semestre VIII" },
    {
      name: "Técnicas de Intervención y Tratamiento Psicológico",
      semester: "Semestre VIII",
    },
    { name: "Consultoria Organizacional I", semester: "Semestre IX" },
    { name: "Enseñanza Social de la Iglesia", semester: "Semestre IX" },
    { name: "Prácticas Pre Profesionales I", semester: "Semestre IX" },
    { name: "Psicología Jurídica", semester: "Semestre IX" },
    { name: "Seminario de Tesis II", semester: "Semestre IX" },
    { name: "Transtornos de la Personalidad", semester: "Semestre IX" },
    { name: "Neuropsicología Clínica", semester: "Semestre IX" },
    { name: "Psicología de la Excepcionalidad", semester: "Semestre IX" },
    {
      name: "Psicología del Consumo y Publicidad",
      semester: "Semestre IX",
    },
    { name: "Análisis de la Realidad Peruana", semester: "Semestre X" },
    { name: "Consultoría Organizacional II", semester: "Semestre X" },
    { name: "Ética Profesional", semester: "Semestre X" },
    { name: "Prácticas Preprofesionales II", semester: "Semestre X" },
    {
      name: "Psicología y Espiritualidad Cristiana",
      semester: "Semestre X",
    },
    { name: "Visión Integral de la Psicoterapia", semester: "Semestre X" },
    { name: "Liderazgo Personal e Institucional", semester: "Semestre X" },
    { name: "Psicología de las adicciones", semester: "Semestre X" },
    { name: "Trastornos del Lenguaje", semester: "Semestre X" },
  ],
};
